/* Read more/less on product page and quickview */
jQuery(document).ready(function($)
 {
  $('.readmore').insertAfter( '.product-description' );
  $('body').on('click', '.readmore', function() {
    //$('.readmore').click(function (event) {
    console.log("hello clcik");
    event.preventDefault();
    var description = document.querySelector('.product-description');
    console.log(description.style.height)
    if (description.style.height === ''){
      description.style.height = 'auto';
    } else if (description.style.height === 'auto'){
      description.style.height = '';
    }
    else{
      description.style.height = '52px';
    }

    $(this).text($(this).text() == 'Read less...' ? 'Read more...' : 'Read less...');
  });
  
});


// $('.readmore').toggleClass(function (event) {
//     $(this).prev(".product-description").addClass("cust-botm-remove");
//   })



$( ".readmore" ).click(function() {
  $( this ).prev(".product-description").toggleClass( "cust-botm-remove" );
});
/* End Read more/less on product page and quickview */


/* Homepage merchants auto scroll */
const slideshowEl = document.querySelector('#section-about-us-homepage .grid');

if (slideshowEl) {
    // speed of ticker
    let tickerSpeed = 1;
    let flickity = null;
    let isPaused = false;

    // functions
    const update = () => {
         if (isPaused) return;
         if (flickity.slides) {
              flickity.x = (flickity.x - tickerSpeed) % flickity.slideableWidth;
              flickity.selectedIndex = flickity.dragEndRestingSelect();
              flickity.updateSelectedSlide();
              flickity.settle(flickity.x);
         }
         window.requestAnimationFrame(update);
    };

    const pause = () => {
         isPaused = true;
    };

    const play = () => {
         if (isPaused) {
              isPaused = false;
              window.requestAnimationFrame(update);
         }
    };

    // create flickity instance
    flickity = new Flickity(slideshowEl, {
         cellAlign: 'left',
         setGallerySize: true,
         dragThreshold: 25,
         pageDots: false,
         prevNextButtons: false,
         autoPlay: false,
         draggable: true,
         wrapAround: true,
         selectedAttraction: 0.015,
         friction: 0.25
    });
    flickity.x = 0;

    // event listeners
    slideshowEl.addEventListener('mouseenter', pause, false);
    slideshowEl.addEventListener('focusin', pause, false);
    slideshowEl.addEventListener('mouseleave', play, false);
    slideshowEl.addEventListener('focusout', play, false);

    flickity.on('dragStart', () => {
         isPaused = true;
    });

    // start ticker
    update();
}
/* END homepage merchants auto scroll */